<template>
  <v-content class="login">
    <!-- logo -->
    <v-row align-content="center" justify="center" no-gutters class="logo">
      <img :src="logo" height="50px" style="width:auto; max-width:100%;" />
    </v-row>

    <div class="px-3 mt-10">
      <p class="body-2 mb-10">新規登録ボタンをタップすると、入力されたメールアドレスに仮登録完了メールを送信いたします。メールに記載されている6桁の認証コードを入力して本登録を完了してください。</p>
      <ValidationObserver ref="observer">
      <v-row class="">
        <v-col cols="12" sm="6" class="pb-0">
          <p class="subtitle-2 font-weight-black ma-0">メールアドレス</p>
          <ValidationProvider v-slot="{ errors }" name="メールアドレス" rules="required|email|max:254">
          <v-text-field v-model="mail" label single-line outlined dense :error-messages="errors" required></v-text-field>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="6" class="pb-0">
          <p class="subtitle-2 font-weight-black ma-0">パスワード</p>
          <ValidationProvider v-slot="{ errors }" name="パスワード" rules="required|alpha_num|max:64|min:8">
          <v-text-field v-model="password" single-line outlined dense :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'" @click:append="show = !show" :error-messages="errors" required></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>
        <v-row class="" v-if="lineMiniFlg === true">
          <v-col cols="12" sm="6" class="pb-0">
            <p class="subtitle-2 font-weight-black ma-0">LINE ID</p>
            <ValidationProvider v-slot="{ errors }" vid="lineid" name="LINE ID" rules="">
              <v-text-field v-model="lineid" label single-line outlined dense :error-messages="errors"></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" sm="6" class="pb-0">
            <p class="subtitle-2 font-weight-black ma-0">PINコード</p>
            <ValidationProvider v-slot="{ errors }" vid="pincode" name="PINコード" rules="my_rule:lineid">
              <v-text-field v-model="pincode" single-line outlined dense :error-messages="errors"></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>
      </ValidationObserver>

      <div class="text-center">
        <v-btn rounded class="maincolor-bg default_button mb-5" @click="regist()">新規登録</v-btn>
        <v-btn rounded class="caption font-weight-black" style="background-color:#EFEFEF;" to="index">ログイン画面に戻る</v-btn>
      </div>

      <div class="text-center caption pt-10">
        <p class="">本アプリをご利用の際には、<router-link :to="'/info/rule'">利用規約</router-link>をご確認ください。</p>
        <p class="text-left caption pt-10">【仮登録メールが届かない場合】<br><br>
        ＜メールアドレス入力前の注意点＞<br>
          ・配信ドメイン『@usen.com 』を受信できるよう設定してください。<br>
          ・迷惑メール防止機能は、一時的に解除、もしくは強度を下げてください。<br>
          ・自分に空メールを送信し、そのメールが受信できるか確認してください。<br><br>
          ＜メールアドレス入力時の注意点＞<br>
          スペルミス、打ち間違い、記号の入力ミス(ドット「．」ハイフン「－」などの入力数間違いなど)にご注意ください。
        </p>
        <p class=""><router-link to="/info/legal">特定商取引法に基づく表記</router-link></p>
        <p class="caption" v-if="mailto">
            <v-icon>far fa-envelope</v-icon> <a :href="'mailto:'+mailto">お問い合わせ</a>
        </p>
      </div>

      <p class="text-center" v-if="copyright" style="font-size: 12px; margin-top:60px;">© {{copyright}} All right reserved.</p>

    </div>

    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>
  </v-content>
</template>

<script>
import { required, email, alpha_num, max, min } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
setInteractionMode('eager')
extend('required', {
  ...required,
  message: '{_field_} は必須項目です。',
})

extend('email', {
  ...email,
  message: '正しいメールアドレス形式ではありません',
})

extend('alpha_num', {
  ...alpha_num,
  message: '英数字のみが利用できます',
})

extend('max', {
  ...max,
  message: '{length}文字以内で入力してください。',
})

extend('min', {
  ...min,
  message: '{length}文字以上で入力してください。',
})

extend('my_rule', {
  params: [{
    name: 'lineid',
    isTarget: true
  }],
  message: '{_field_}は必須項目です。',
  validate(pincode, {lineid}) {
    return !(lineid !== "" && pincode === "");

  },
  computesRequired: true
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    var shop_name_data = this.storageGet('shop_name');
    if (shop_name_data == false) {
      shop_name_data = '新規登録';
    }
    return {
      mail: null,
      show: false,
      password: '',
      lineid: '',
      pincode: '',
      logo: this.storageGet('top_logo_image'),
      mailto: this.storageGet('inquiry_mail'),
      shop_name: shop_name_data,
      copyright: this.storageGet('copyright'),
      result: [],
      loading: false,
      lineMiniFlg: false
    };
  },
  async created () {
    this.init = this.storageGet('*');
    let params = {
      'sid': this.init.sid,
      'device_uid': this.init.device_uid,
      'device_id': this.init.device_id,
      'os': this.init.os,
      'key': this.init.key,
      'location': 0,
      'feature_id': this.init.feature_id,
      'page': this.page
    }

    if (this.init.sid) {
      params['shop_id'] = this.init.sid
    }

    let shoplist_req = { params: params }
    try {
      let res = await this.apiCall('line/user/agreement', shoplist_req, 'get')

      if (!res) {
        return;
      }
      // 契約情報の取得
      if(res.agreements_list != null){
        res.agreements_list.forEach( function( value ) {
          if(value.agreements_type===2) {
            this.lineMiniFlg = true;
          }
        }, this)
      }
    } catch(e) {
      return 0;
    }

  },
  methods: {
    regist: function() {
      if (this.lineMiniFlg === true) {
        console.log(this.storageGet('sid'));
        this.$refs.observer.validate().then(async result => {
          if (result) {
            try {
              new Promise(function (resolve) {
                resolve('result');
              })
                  .then(async result => {
                    let line_res;

                    //loadingを表示
                    this.loading = true
                      // LINE IDが入力されている場合、連携APIを呼び出し
                      if (this.lineid !== "") {
                      let line_req = {
                        'sid': this.storageGet('sid'),
                        'service_cd': this.storageGet('service_cd'),
                        'user_id': this.storageGet('user_id'),
                        'line_id': this.lineid,
                        'line_exchange_code': this.pincode,
                        'shop_id': this.storageGet('sid')
                      }
                      line_res = await this.apiCall('/line/user/update', line_req, 'post');
                    }
                    return [result, line_res];
                  })
                  .then(result => {
                    let next_result = result[0];
                    let line_res = result[1];
                    if (this.lineid !== "") {
                      console.log(line_res);
                      this.$set(this, 'result', line_res);
                      if (!line_res) {
                        this.loading = false
                        this.callDialog('エラー', 'LINEへの連携に失敗しました。', 1);
                        return false;
                      }
                      if (typeof line_res.status != 'undefined') {
                        if (line_res.status === 102) {
                          this.loading = false
                          this.callDialog('エラー', 'LINEアカウントが存在しません。', 1);
                          return false;
                        }
                        if (line_res.status === 902) {
                          this.loading = false
                          this.callDialog('エラー', 'LINEへの連携に失敗しました。', 1);
                          return false;
                        }
                      }
                    }
                    return [next_result, line_res];
                  })
                  .then(async result => {
                    if (result) {
                      let next_result = result[0];
                      let line_res = result[1];

                      // 事業者情報取得API実行
                      var business_service_req = {
                        params: {
                          'sid': this.storageGet('sid')
                        }
                      }
                      var business_service_res = await this.apiCall('/business-service/get-info', business_service_req)

                      // ユーザ仮登録API実行
                      var regist_req = {
                        'sid': this.storageGet('sid'),
                        'service_cd': this.storageGet('service_cd'),
                        'login_id': this.mail,
                        'password': this.password,
                        'shop_name': this.shop_name,
                        'email': business_service_res.data.email,
                        'email_name': business_service_res.data.email_name
                      }
                      var res = await this.apiCall('/temporary-user', regist_req, 'post', 2);
                      return [next_result, line_res, res];
                    }
                    return result;
                  })
                  .then(result => {
                    if (result) {
                      let next_result = result[0];
                      let line_res = result[1];
                      let res = result[2];

                      this.$set(this, 'result', res);
                      if (!res) {
                        this.loading = false
                        return false;
                      }
                      if (typeof res.status != 'undefined') {
                        if (res.status === 702) {
                          this.callDialog('エラー', '登録済のメールアドレスです', 6);
                        }
                      }

                      if (!line_res && this.lineid !== "") {
                        // LINEアカウントを連携したの場合、user_idをLINEアカウントのuser_idへ置換
                        this.storageSave(JSON.stringify({
                          // eslint-disable-next-line no-undef
                          'user_id': line_res.user_id,
                          'auth_login_id': this.mail,
                          'auth_password': this.password
                        }));
                      } else {
                        this.storageSave(JSON.stringify({
                          'auth_login_id': this.mail,
                          'auth_password': this.password
                        }));
                      }
                      return [next_result, line_res, res];
                    }
                    return false;
                  })
                  .then(result => {
                    if (result) {
                      this.$router.push('authcode');
                    }
                  })
                  // eslint-disable-next-line no-unused-vars
                  .catch(e => {
                    this.loading = false
                    this.callDialog('エラー', '予期せぬエラーが発生しました。', 1);
                  });
            } catch (e) {
              this.loading = false
              this.callDialog('エラー', '予期せぬエラーが発生しました。', 1);
            }
          }
        });
      } else {
        this.$refs.observer.validate().then(async result => {
          if (result) {
            try {
              //loadingを表示
              this.loading = true

              // 事業者情報取得API実行
              var business_service_req = {
                params: {
                  'sid': this.storageGet('sid')
                }
              }
              var business_service_res = await this.apiCall('/business-service/get-info', business_service_req)

              // ユーザ仮登録API実行
              var regist_req = {
                'sid': this.storageGet('sid'),
                'service_cd': this.storageGet('service_cd'),
                'login_id': this.mail,
                'password': this.password,
                'shop_name': this.shop_name,
                'email': business_service_res.data.email,
                'email_name': business_service_res.data.email_name
              }
              var res = await this.apiCall('/temporary-user', regist_req, 'post', 2);
              this.$set(this, 'result', res);
              //console.log(res);
              if (!res) {
                this.loading = false
                return false;
              }
              if (res.status == 702) {
                this.callDialog('エラー', '登録済のメールアドレスです', 6);
              } else {
                this.storageSave(JSON.stringify({'auth_login_id': this.mail, 'auth_password': this.password}));
                this.$router.push('authcode');
              }
            } catch (e) {
              this.loading = false
            }
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.fontsize12>>>label {
  font-size: 12px;
}

a {
  color: #333333;
}
</style>
